import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

export default class MobileDeliveryNotes extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	render() {
		const { sectionTitle, consigneeNotes, shipperNotes, orderRemark, classes } = this.props;

		return (
			<>
				<div className={classes.productTitle}>{sectionTitle}</div>
				<div className={classes.notesContainer}>
					<div className={classes.notesSection}>
						{_.isEmpty(consigneeNotes) && (
							<span className={classes.emptyNotes}>Consignee notes are empty.</span>
						)}
						{!_.isEmpty(consigneeNotes) && <strong>Consignee Notes: </strong>}
						{consigneeNotes.map((note, i) => {
							return (
								<span key={`consigneeNote${i}`}>
									{note}
									<br />
								</span>
							);
						})}
					</div>

					<div className={classes.notesSection}>
						{_.isEmpty(shipperNotes) && (
							<span className={classes.emptyNotes}>Shipper notes are empty.</span>
						)}
						{!_.isEmpty(shipperNotes) && <strong>Shipper Notes: </strong>}
						{shipperNotes.map((note, i) => {
							return (
								<span key={`shipperNote${i}`}>
									{note}
									<br />
								</span>
							);
						})}
					</div>

					<div className={classes.notesSection}>
						{!orderRemark && <span className={classes.emptyNotes}>Order remarks are empty.</span>}
						{orderRemark && (
							<>
								<strong>Order Remarks: </strong>
								<span>{orderRemark}</span>
							</>
						)}
					</div>
				</div>
			</>
		);
	}
}

MobileDeliveryNotes.propTypes = {
	classes: PropTypes.object.isRequired,
	commodities: PropTypes.array,
};
